export default [
  {
    path: "ecologicalServices",
    component: () => import("@/views/modules/ecology/index"),
    meta: { title: "生态服务", needToken: true },
    children: [
      {
        path: "",
        name: "ecologicalServices",
        component: () => import("@/views/modules/ecology/home"),
        meta: { title: "生态服务", needToken: true },
      },
      {
        path: "/ecologicalServices/company-edit",
        name: "ecologicalServices-company-edit",
        component: () => import("@/views/modules/ecology/company/edit"),
        meta: { title: "供应商能力申请", needToken: true },
      },
      {
        path: "/ecologicalServices/company-detail",
        name: "ecologicalServices-company-detail",
        component: () => import("@/views/modules/ecology/company/detail"),
        meta: { title: "供应商能力申请详情", needToken: true },
      },
      {
        path: "/ecologicalServices/person-edit",
        name: "ecologicalServices-person-edit",
        component: () => import("@/views/modules/ecology/person/edit"),
        meta: { title: "个人能力申请", needToken: true },
      },
      {
        path: "/ecologicalServices/person-detail",
        name: "ecologicalServices-person-detail",
        component: () => import("@/views/modules/ecology/person/detail"),
        meta: { title: "个人能力申请详情", needToken: true },
      },
      {
        path: "/ecologicalServices/account-edit",
        name: "ecologicalServices-account-edit",
        component: () => import("@/views/modules/ecology/account/edit"),
        meta: { title: "子账号申请", needToken: true },
      },
      {
        path: "/ecologicalServices/account-detail",
        name: "ecologicalServices-account-detail",
        component: () => import("@/views/modules/ecology/account/detail"),
        meta: { title: "子账号申请详情", needToken: true },
      },
      {
        path: "/ecologicalServices/report-list",
        name: "ecologicalServices-report-list",
        component: () => import("@/views/modules/ecology/report/list"),
        meta: { title: "报工列表", needToken: true },
      },
      {
        path: "/ecologicalServices/report-edit",
        name: "ecologicalServices-report-edit",
        component: () => import("@/views/modules/ecology/report/edit"),
        meta: { title: "报工申请", needToken: true },
      },
      {
        path: "/ecologicalServices/report-detail",
        name: "ecologicalServices-report-detail",
        component: () => import("@/views/modules/ecology/report/detail"),
        meta: { title: "报工详情", needToken: true },
      },
      {
        path: "/ecologicalServices/settlement-list",
        name: "ecologicalServices-settlement-list",
        component: () => import("@/views/modules/ecology/settlement/list"),
        meta: { title: "结算列表", needToken: true },
      },
      {
        path: "/ecologicalServices/settlement-edit",
        name: "ecologicalServices-settlement-edit",
        component: () => import("@/views/modules/ecology/settlement/edit"),
        meta: { title: "结算申请", needToken: true },
      },
      {
        path: "/ecologicalServices/settlement-detail",
        name: "ecologicalServices-settlement-detail",
        component: () => import("@/views/modules/ecology/settlement/detail"),
        meta: { title: "结算详情", needToken: true },
      },
    ],
  },
];
